module.exports = __webpack_public_path__ + "static/the-threebody-problem-d21b0db38e4123bb3532b0a35f0e2fdd.jpg";